import { useState, useEffect } from "react";
import { FilePen } from "lucide-react";
import Typography from "../../components/Typography/Typography";

const InfoBlock = ({ title, content, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(content);
  const [initialValue, setInitialValue] = useState(content);

  // Aggiorna il valore locale quando cambia il content prop
  useEffect(() => {
    setLocalValue(content);
    setInitialValue(content);
  }, [content]);

  const handleSave = () => {
    setIsEditing(false);
    
    // Verifica se il contenuto è stato effettivamente modificato
    if (localValue !== initialValue) {
      onChange?.(localValue);
      setInitialValue(localValue); // Aggiorna il valore iniziale
    }
  };

  const handleCancel = () => {
    setLocalValue(initialValue); // Ripristina il valore originale
    setIsEditing(false);
  };

  return (
    <div className="flex flex-col gap-1 w-full border-[2px] border-gray-200 bg-gray-100 rounded-[12px] p-4">
      <div className="flex w-full justify-between items-start gap-4">
        <Typography size="12" color="gray-600" weight="md">{title}</Typography>
        <FilePen
          size={16}
          className="text-gray-600 hover:text-black transition-colors transition-200 cursor-pointer mt-1"
          onClick={() => setIsEditing(true)}
        />
      </div>
      {isEditing ? (
        <div className="w-full">
          <textarea
            className="w-full resize-none bg-transparent border-none focus:outline-none focus:ring-0 text-base font-semibold leading-snug py-0 px-0 m-0"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={handleSave}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); 
                e.target.blur();
              } else if (e.key === 'Escape') {
                e.preventDefault();
                handleCancel();
              }
            }}
            autoFocus
            style={{ fontFamily: 'inherit', minHeight: '24px' }}
          />
        </div>
      ) : (
        <Typography size="16" weight="sb">
          {localValue}
        </Typography>
      )}
    </div>
  );
};

export default InfoBlock;